import styled from 'styled-components';
import { Row, Image } from 'react-bootstrap';

import { CheckBox } from '../LoanVariablesDialog/components/common/ConfirmCheckBox/styles';

export const Panel = styled.div<{ isSuccessMessage?: boolean }>`
  padding: ${({ isSuccessMessage }) => (isSuccessMessage ? '30px 95px' : '18px 14px')};
  display: flex;
  flex-direction: column;

  .row:last-child {
    margin-bottom: 0;
  }

  .row {
    margin-bottom: 16px;
  }
  & > ${CheckBox} {
    margin-top: 2px;
  }
`;

export const FormPanel = styled(Panel)`
  background-color: ${({ theme: { colors } }) => colors.white};
  border-radius: 4px;
  box-shadow: 0 1px 1px rgb(0 0 0 / 5%);

  .btn,
  .btn:hover,
  .btn:focus,
  .btn:checked,
  .btn.btn-primary:not(:disabled):not(.disabled):active,
  .show > .btn.btn-primary.dropdown-toggle {
    font-weight: normal;
  }
`;

export const ConfirmCheckboxesPanel = styled(Panel)`
  padding-bottom: 0;
`;

export const FormMessage = styled(Row)`
  font-weight: bold;
`;

export const ButtonsBlock = styled.div`
  .btn:first-child {
    margin-right: 7px;
  }
`;

export const SuccessMessage = styled(Row)`
  padding: 0;
  text-align: center;
  font-weight: bold;
`;

export const SuccessSubmitLogo = styled(Image)`
  height: 70px;
  margin: 10px 0 20px 0;
`;
